export const DATE_CELL_KEYS = ['startDate', 'endDate', 'isOngoing', 'isDayEntitlement', 'expiryDate'] as const;
